<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App',
    mounted() {
      let openTable = document.createElement('script')
      openTable.setAttribute('src', '//www.opentable.ie/widget/reservation/loader?rid=167163&type=standard&theme=standard&iframe=true&overlay=false&domain=ie&lang=en-IE')
      const reservation = document.getElementById("reservation");
      reservation.appendChild(openTable);
    }
  }
</script>

<style lang="scss">
  @import 'src/assets/scss/_variables.scss';
  @import 'src/assets/scss/_mixins.scss';
  @import 'src/assets/scss/reset.scss';
  @import 'src/assets/scss/fonts.scss';
  @import 'src/assets/scss/base.scss';
  @import 'src/assets/scss/animations.scss';
  @import 'src/assets/scss/footer.scss';
  @import 'src/assets/scss/home.scss';
  @import 'src/assets/scss/reservations.scss';
</style>
